// import React from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button
// } from "@mui/material";

// export interface PrintData {
//   orderNumber: string;
//   customerName: string;
//   orderItems: {
//     productId: string;
//     productName: string;
//     serviceName: string;
//     quantity: number;
//     itemTag: string;
//   }[];
// }

// interface PrintConfirmationModalProps {
//   open: boolean;
//   onClose: () => void;
//   onConfirm: () => void;
//   printData: PrintData | null;
// }

// const PrintConfirmationModal: React.FC<PrintConfirmationModalProps> = ({
//   open,
//   onClose,
//   onConfirm,
//   printData
// }) => {
//   // Group products by productId and merge services
//   const groupedProducts = printData?.orderItems.reduce((acc, item) => {
//     const existingProduct = acc.find((p) => p.productId === item.productId);

//     if (existingProduct) {
//       // If product already exists, add service to the existing entry
//       existingProduct.services.push(item.serviceName);
//     } else {
//       // If product doesn't exist, create a new entry
//       acc.push({
//         productId: item.productId,
//         productName: item.productName,
//         services: [item.serviceName], // Store as array to join later
//         quantity: item.quantity,
//         itemTag: item.itemTag
//       });
//     }

//     return acc;
//   }, [] as { productId: string; productName: string; services: string[]; quantity: number; itemTag: string }[]);

//   return (
//     <Dialog open={open} onClose={onClose}>
//       <DialogTitle>Print Tags</DialogTitle>
//       <DialogContent>
//         <p>Are you sure you want to print the tags for this order?</p>
//         <p>
//           <strong>Order No:</strong> {printData?.orderNumber}
//         </p>
//         <p>
//           <strong>Customer:</strong> {printData?.customerName}
//         </p>

//         {/* Display each product with combined services */}
//         {groupedProducts?.map((item, index) => (
//           <div
//             key={index}
//             style={{
//               borderBottom: "1px solid #ccc",
//               marginBottom: "10px",
//               paddingBottom: "5px"
//             }}
//           >
//             <p>
//               <strong>Product:</strong> {item.productName}
//             </p>
//             <p>
//               <strong>Services:</strong> {item.services.join(", ")}
//             </p>
//             <p>
//               <strong>Quantity:</strong> {item.quantity}
//             </p>
//             <p>
//               <strong>Tag ID:</strong> {item.itemTag}
//             </p>
//           </div>
//         ))}
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="error">
//           Cancel
//         </Button>
//         <Button onClick={onConfirm} color="primary">
//           Print
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default PrintConfirmationModal;

import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Box } from "@mui/material";

interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  question: string;
  actionText1: string;
  actionText2: string;
  optionText?:string;
}

const ConfirmDialog : React.FC<ConfirmDialogProps> = ({ open, onClose, onConfirm,title,question,actionText1,actionText2,optionText }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          p: 2,
          backgroundColor: "background.paper",
          boxShadow: 10,
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h6"
          fontWeight="bold"
          textAlign="center"
          gutterBottom
        >
          {title}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box textAlign="center" mb={1}>
          <Typography variant="body1" color="text.secondary">
            {question}
          </Typography>
        </Box>

        {optionText && (
          <Box textAlign="center">
            <Typography variant="caption" color="error">
              {optionText}
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ justifyContent: "center", gap: 2, pt: 2 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          color="error"
          sx={{ minWidth: 120, fontWeight: "bold", borderRadius: 2 }}
        >
          {actionText1}
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          color="primary"
          sx={{ minWidth: 120, fontWeight: "bold", borderRadius: 2 }}
        >
          {actionText2}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;


